import { useQuery } from '@tanstack/react-query';
import { listWebhooks, getWebhook } from '@/lib/api/webhooks';
import type { ListWebhooksParams } from '@/types/webhook';

/**
 * Hook to fetch a paginated list of webhooks.
 *
 * @param params - Optional filter and pagination parameters
 */
export function useWebhooks(params?: ListWebhooksParams) {
  return useQuery({
    queryKey: ['webhooks', params],
    queryFn: () => listWebhooks(params),
    staleTime: 30_000, // 30 seconds
  });
}

/**
 * Hook to fetch a single webhook by ID.
 *
 * @param eventId - The webhook event ID
 */
export function useWebhook(eventId: string) {
  return useQuery({
    queryKey: ['webhooks', eventId],
    queryFn: () => getWebhook(eventId),
    enabled: !!eventId,
  });
}
